import { IconFont, Input, pointer } from '@lighthouse/bui'
import styled from 'styled-components'

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    /* gap: 8px; */
`

export const Icon = styled(IconFont)<{ mr?: number }>`
    font-size: 16px;
    color: var(--color-gray-500);
    ${pointer};
    margin-right: ${({ mr }) => mr || 0}px;
`

export const CodeEditor = styled.div`
    padding: 8px;
    & * {
        word-break: normal;
    }
`

export const VariableItem = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 8px 0 4px 0;
`

export const InputWrapper = styled.div`
    width: 162px;
    height: 32px;
`

export const SelectWrapper = styled.div`
    width: 118px;
    height: 32px;
    margin: 0 8px;
`

export const DeleteWrapper = styled.div`
    width: 32px;
    height: 32px;
    background: #eceff4;
    border-radius: 6px;
    line-height: 32px;
    text-align: center;
    ${pointer};
`
